<template>
  <div>
    <ViewTemplate :table-props="mappingColumns" :project-param-id="projectParamId" :mapper-param-id="mapperParamId" @openMermaidChart="openMermaidChart" />
    <MermaidChart v-if="showMermaidChart" :data="mermaidChartData" :title="mermaidChartTitle" @close="closeMermaidChart" />
  </div>
</template>

<script>
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import TabContentView from "./TabContentView.vue";
import ViewTemplate from "@/components/ViewTemplate.vue";
import MermaidChart from "@/components/MermaidChart.vue";

export default {
  name: pageViews.PROCESS_DETAILS_VIEW,
  methods: {
    setValuesToStore(type) {
      Store.commit("setType", type);
    },
    openMermaidChart(data) {
      this.mermaidChartData = data["mermaid_text"] ;
      this.mermaidChartTitle = data["title"];
      this.showMermaidChart = true;
    },
    closeMermaidChart() {
      this.showMermaidChart = false;
      this.mermaidChartData = null;
      this.mermaidChartTitle = null; // Reset the title
    }
  },
  mounted() {
    this.setValuesToStore(type.MAPPER_PROCESS_DETAILS); // Ensure correct type is set
  },
  components: {
    ViewTemplate,
    TabContentView,
    MermaidChart,
  },
  data() {
    return {
      showMermaidChart: false,
      mermaidChartData: null,
        uploadConfigs: {
          action: "generator",
          actionLabel: "Generator",
          title: "Mapper Config Generator",
          type: type.MAPPER_PROCESS_DETAILS, // Ensure this matches the backend expectation
          accept: ".zip",
        },
        mappingColumns: {
          type: type.MAPPER_PROCESS_DETAILS, // Ensure this matches the backend expectation
          isMultiSelectionAllowed: true,
          defaultSortOrder: { name: "asc", label: "Ascending" },
          defaultSortColumn: { name: "Process", label: "Process" },
          configs: [
          { name: "id", label: "id", order: 0, isSortable: true, defaultSelected: false, search: false, textAlign: "left" },
          { name: "usecaseLocation", label: "Use Case Location", order: 1, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "usecase", label: "Use Case", order: 2, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "processLocation", label: "Process Location", order: 3, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "process", label: "Process", order: 4, isSortable: true, defaultSelected: true, textAlign: "left",isActionable: true },
          { name: "processActivitiesCount", label: "Activity Count", order: 5, isSortable: true,defaultSelected: true,textAlign: "center" },
          { name: "processMappingCount", label: "Mapping Count", order: 6, isSortable: true, defaultSelected: true , textAlign: "center"},
          { name: "processTransitionCount", label: "Transition Count", order: 7, isSortable: true, defaultSelected: true , textAlign: "center"},
          { name: "EMS", label: "EMS", order: 8, isSortable: false, defaultSelected: true, search: false },
          { name: "JMS", label: "JMS", order: 9, isSortable: false, defaultSelected: true, search: false },
          { name: "RV", label: "RV", order: 10, isSortable: false, defaultSelected: true, search: false },
          { name: "Kafka", label: "Kafka", order: 11, isSortable: false, defaultSelected: true, search: false },
          { name: "AWS SQS", label: "AWS SQS", order: 12, isSortable: false, defaultSelected: true, search: false },
          { name: "RookS3 Adapter", label: "RookS3 Adapter", order: 13, isSortable: false, defaultSelected: true, search: false },
          { name: "File Adapter", label: "File Adapter", order: 14, isSortable: false, defaultSelected: true, search: false },
          { name: "IPFeedEnterprise Adapter", label: "IPFeedEnterprise Adapter", order: 15, isSortable: false, defaultSelected: true, search: false },
          { name: "GPOS DB Adapter", label: "GPOS DB Adapter", order: 16, isSortable: false, defaultSelected: true, search: false },
          { name: "Central DB Adapter", label: "Central DB Adapter", order: 17, isSortable: false, defaultSelected: true, search: false },
          { name: "AS400 Adapter", label: "AS400 Adapter", order: 18, isSortable: false, defaultSelected: true, search: false },
          { name: "Oracle EBS", label: "Oracle EBS", order: 19, isSortable: false, defaultSelected: true, search: false },
          { name: "Java", label: "Java", order: 20, isSortable: false, defaultSelected: true, search: false },
          { name: "Mappers", label: "Mappers", order: 21, isSortable: false, defaultSelected: true, search: false },
          { name: "XML", label: "XML", order: 22, isSortable: false, defaultSelected: true, search: false },
          { name: "AS400 DB", label: "AS400 DB", order: 23, isSortable: false, defaultSelected: true, search: false },
          { name: "JDBC", label: "JDBC", order: 24, isSortable: false, defaultSelected: true, search: false },
          { name: "Mail", label: "Mail", order: 25, isSortable: false, defaultSelected: true, search: false },
          { name: "S/FTP", label: "S/FTP", order: 26, isSortable: false, defaultSelected: true, search: false },
          { name: "File", label: "File", order: 27, isSortable: false, defaultSelected: true, search: false },
          { name: "JSON", label: "JSON", order: 28, isSortable: false, defaultSelected: true, search: false },
          { name: "Timer", label: "Timer", order: 29, isSortable: false, defaultSelected: true, search: false },
          { name: "HTTP", label: "HTTP", order: 30, isSortable: false, defaultSelected: true, search: false },
          { name: "SOAP", label: "SOAP", order: 31, isSortable: false, defaultSelected: true, search: false },
          { name: "REST", label: "REST", order: 32, isSortable: false, defaultSelected: true, search: false },
          { name: "SSL Cert", label: "SSL Cert", order: 33, isSortable: false, defaultSelected: true, search: false }
        ],
        actions: {
          viewPopup: { label: 'View Output' },
          download: { label: 'Request Download' },
          calculate: { label: 'Calculate Complexity' },
        },
      },
    };
  },
  props: ["projectParamId", "mapperParamId"],
};
</script>